import { motion } from 'framer-motion';
import { MANIFESTO } from '@/data/site';

const EASE = [0.16, 1, 0.3, 1];

export default function Manifesto() {
  return (
    <section className="relative bg-[#FAFAF5] py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#1D4ED8] flex items-center gap-3">
              <span className="w-8 h-px bg-[#1D4ED8]" /> Manifesto
            </div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display uppercase text-[#0A0A0A] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Four rules the crew<br />actually lives by.
            </h2>
          </div>
        </div>

        <div className="grid gap-0 border-t border-black/10">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.05 }}
              className="grid md:grid-cols-12 gap-8 border-b border-black/10 py-10 md:py-12 group"
            >
              <div className="md:col-span-2 font-mono-label text-[#0A0A0A]/60 text-sm md:text-base tracking-[0.24em] group-hover:text-[#1D4ED8] transition-colors">
                {m.num}
              </div>
              <div className="md:col-span-6">
                <h3 className="font-display uppercase text-[#0A0A0A] text-2xl md:text-4xl leading-tight tracking-tight">
                  {m.title}
                </h3>
              </div>
              <div className="md:col-span-4 text-[#0A0A0A]/70 leading-relaxed">
                {m.body}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
